/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import * as ActionTypes from './ActionTypes';

const initialState = {
  familyPlanningDrugsInvSearchObj: {},
  errorMsgFamilyPlanningDrugsInv: [],
  planType: [],
  quarter: '',
  rebateProgram: [],
  isLoading: false,
  searchResult: [],
  displayObj: {
    setRebateProgram: '',
    planType: [],
    quarter: '',
    rebateProgram: [],
    rebateProgrameName: '',
    searchResult: [],
  },
};

const reducer = (state = initialState, Actions) => {
  switch (Actions.type) {
    case ActionTypes.GET_FAMILY_PLANNING_DRUGS_INV_SEARCH_OBJ:
      return { ...state, familyPlanningDrugsInvSearchObj: Actions.screenData };
    case ActionTypes.IS_LOADING:
      return { ...state, isLoading: Actions.isLoading };
    case ActionTypes.GET_ERROR_MSG_FAMILY_PLANNING_DRUGS_INV:
      return { ...state, errorMsgFamilyPlanningDrugsInv: Actions.payload };
    case ActionTypes.GET_PLAN_TYPE_DATA:
      return { ...state, planType: Actions.payload };
    // case ActionTypes.GET_REBATE_PROGRAM:
    //   return { ...state, rebateProgram: Actions.payload };
    case ActionTypes.DISPATCH_QTR_VALUE:
      return { ...state, quarter: Actions.payload };
    case ActionTypes.SET_REBATE_PROGRAM:
      return { ...state, setRebateProgram: Actions.payload };
    case ActionTypes.SET_DISPLAY_OBJ_FAMILY_INV:
      return { ...state, ...Actions.payload };
    case ActionTypes.SET_FAMILY_PLANNING_DRUGS_INV_DETAIL:
      let displayObj = {
        ...state.displayObj,
        searchResult: Actions.payload,
      };
      return { ...state, searchResult: Actions.payload, displayObj };
    case ActionTypes.REFRESH_FAMILY_PLANNING_DRUGS_INV:
      return {
        ...initialState,
        displayObj: state.displayObj,
      };
    case ActionTypes.REFRESH_FAMILY_PLANNING_DRUGS_INV_DISPLAY:
      return {
        ...initialState,
        displayObj: state.displayObj,
      };
    default:
      return state;
  }
};

export default reducer;
